import { render, staticRenderFns } from "./ApprovedList.vue?vue&type=template&id=6a76e3f7"
import script from "./ApprovedList.vue?vue&type=script&lang=js"
export * from "./ApprovedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports